var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "projectUploadVexModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.upload_vex"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.file = null
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.reset")))]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    size: "md",
                    variant: "primary",
                    disabled: _vm.file == null,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.upload()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.upload")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-form-file", {
        staticClass: "mb-2",
        attrs: {
          placeholder: _vm.$t("message.no_file_chosen"),
          browseText: _vm.$t("message.browse"),
        },
        model: {
          value: _vm.file,
          callback: function ($$v) {
            _vm.file = $$v
          },
          expression: "file",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }